module.exports = __webpack_public_path__ + "static/media/4H.8fccba55.jpg";